/** Parse a route-param id string into a validated positive integer, or `undefined` if invalid. */
export function parseEntityId<T extends number>(
  value: string | undefined,
): T | undefined {
  if (value == null || value === '') {
    return undefined;
  }
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? (parsed as T) : undefined;
}
